import styled from "styled-components";

export const ListQuestionsContainer = styled.div`
    display: flex;
`;
